import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import DashboardLayout from "./Layout";
import { ADMIN_PAGES, MANAGER_PAGES, STAFF_PAGES } from "../constants";
import Page404 from "./Page404";

const AdminPage = (props) => {
  const params = useParams();
  const { user } = props;

  const allowedPages = useMemo(() => {
    if (user.role === "admin") {
      return ADMIN_PAGES;
    } else if (user.role === "manager") {
      return MANAGER_PAGES;
    } else if (user.role === "staff") {
      return STAFF_PAGES;
    } else {
      return [];
    }
  }, [user]);

  const Comp = params?.adminSection
    ? allowedPages.find((page) => page.link === params?.adminSection)
        ?.component || Page404
    : Page404;

  return (
    <div>
      <DashboardLayout props={props}>
        <Comp user={user} />
      </DashboardLayout>
    </div>
  );
};

export default AdminPage;
